import { graphic } from 'echarts/lib/echarts'

export const GRADATION_BAR_SERIES = {
  type: 'bar',
  label: { show: false },
  silent: true,
  data: ['bar', 24],
  barCategoryGap: '60%',
  itemStyle: {
    normal: {
      color: new graphic.LinearGradient(0, 0, 1, 0, [
        { offset: 0.05, color: '#aaddf1' },
        { offset: 0.12, color: '#4765bf' },
        { offset: 0.49, color: '#bc9ce1' },
        { offset: 0.52, color: '#f6e2bb' },
        { offset: 0.57, color: '#fcf6bc' },
        { offset: 0.94, color: '#f7edd0' },
        { offset: 1, color: '#dff4fc' },
      ]),
      barBorderRadius: [6, 6, 6, 6],
      size: [10, 10],
    },
  },
}

export const TIME_LABEL_SCATTER_SERIES = {
  type: 'scatter',
  silent: true,
  itemStyle: {
    color: 'rgba(0,0,0,0)',
  },
  label: {
    show: true,
    position: 'top',
    distance: 15,
    formatter: params => {
      const value = params.value[2]
      if (!value) {
        return ''
      }

      let num = parseInt(value, 10)
      let unit = ''
      switch (num) {
        case 12:
          unit = 'PM'
          break
        case 24:
        case 0:
          unit = 'AM'
          break
        default:
          unit = num > 12 ? 'PM' : 'AM'
      }

      if (num > 12) {
        num = num % 12
      }

      if (num === 0) {
        num = 12
      }
      return num + unit
    },
  },
  data: [
    '20',
    '',
    '22',
    '',
    '24',
    '',
    '2',
    '',
    '4',
    '',
    '6',
    '',
    '8',
    '',
    '10',
    '',
    '12',
    '',
    '14',
    '',
    '16',
    '',
    '18',
    '',
  ].map((time, index) => ({ value: [index, 'bar', time] })),
}
